(function() {
  'use strict';

  angular
    .module('mgpCorregedoriaApp.validacao')
    .factory('DashboardService', DashboardService);

  function DashboardService($http, ngsalConfig) {

    var service = {
      loadEstatisticaRelatoriosEnviados: loadEstatisticaRelatoriosEnviados
    };

    return service;

    function loadEstatisticaRelatoriosEnviados(membros) {

      var promise = $http.get(`/mgp-corregedoria/api/${ngsalConfig.apiVersion}/corregedoria/dashboard/relatorios/enviados`)
        .then((response) => {
          return response.data;
        });

        return promise;
    }
  }

})();
